export const BORDER_DIRECTIONS = ['Top', 'Right', 'Bottom', 'Left'] as const;
export const BORDER_LOGICAL_DIRECTIONS = ['InlineStart', 'InlineEnd'] as const;
export const COMBINED_BORDER_PROPERTIES = [
  ...BORDER_DIRECTIONS,
  ...BORDER_LOGICAL_DIRECTIONS,
] as const;
export type BorderSpecificProperty = 'Style' | 'Width' | 'Color';

export const getBorderProperty = (
  direction:
    | (typeof BORDER_DIRECTIONS)[number]
    | (typeof BORDER_LOGICAL_DIRECTIONS)[number]
    | '',
  property: BorderSpecificProperty,
) => `border${direction}${property}`;
